import React, { forwardRef, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { defaultDecimalPlaces } from 'constants/numeric';
import { Grid } from '@mui/material';
import { addPropertyPrefix, onDynamicInputChange } from 'utils/propertyChangeAdapters';
import { RightsContext } from 'providers/RightsContext';
import OfferAssetPropertyItemComponent from './OfferAssetPropertyItemComponent';

const OfferAssetPropertiesComponent = React.memo(
  ({ properties, validationInfo, loadPropertyDetails, onPropertyChange, processing, addToRefs }) => {
    const { financedAssetPropertiesWrite, readOnlyFull } = useContext(RightsContext);

    const loadPropertyDetailsInternal = useCallback(propertyId => () => loadPropertyDetails(propertyId), [loadPropertyDetails]);
    
    return (
      <Grid container spacing={3}>
        {properties?.map((prop, idx) => {
          const readOnly = !prop.allowWrite || readOnlyFull || !financedAssetPropertiesWrite || processing;
            return (
              prop.allowRead && (
                <Grid item xs={12} md={6} key={prop.propertyId} id={prop.name} ref={ref => addToRefs(ref, prop.name, prop.typeCode)}>
                  <OfferAssetPropertyItemComponent
                    prop={prop}
                    validationInfo={validationInfo}
                    onPropertyChange={onPropertyChange}
                    addPropertyPrefix={addPropertyPrefix(idx)}
                    defaultDecimalPlaces={defaultDecimalPlaces}
                    readOnly={readOnly}
                    loadPropertyDetailsInternal={loadPropertyDetailsInternal}
                    onDynamicInputChange={onDynamicInputChange}
                    idx={idx}
                  />
                </Grid>
              )
            );
        })}
      </Grid>
    );
  }
);
OfferAssetPropertiesComponent.displayName = 'OfferAssetPropertiesComponent';

OfferAssetPropertiesComponent.propTypes = {
  properties: PropTypes.array,
  onPropertyChange: PropTypes.func.isRequired,
  validationInfo: PropTypes.object,
  loadPropertyDetails: PropTypes.func.isRequired,
  processing: PropTypes.bool,
  addToRefs: PropTypes.func.isRequired
};

const MemoizedOfferAssetPropertiesComponent = compose(withTranslation())(OfferAssetPropertiesComponent);

const ForwardedOfferAssetPropertiesComponent = forwardRef((props, ref) => (
  <MemoizedOfferAssetPropertiesComponent {...props} forwardedRef={ref} />
));

ForwardedOfferAssetPropertiesComponent.displayName = 'ForwardedOfferAssetPropertiesComponent';

export default ForwardedOfferAssetPropertiesComponent;
